// extracted by mini-css-extract-plugin
export var leftAlign = "_3y-2";
export var popper = "_3y-0";
export var subtitle = "_3y-1";